import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../store';
import {
  cancelDeletion,
  markAsDeleted
} from '../../../../store/products';
import { text } from '../../../../text';
import { CountdownTimer } from '../../../core/CountdownTimer';
import {
  Image,
  Typography,
  Button
} from '@npm-registry/eapteka-ui';
import { ProductRemovedProps } from './types';
import styles from './ProductRemoved.scss';
import { updateLoadingStatus } from '../../../../store/summary';

export const ProductRemoved: FC<ProductRemovedProps> = ({
  id,
  name,
  picture,
  onDelete,
  onCancel
}) => {
  const dispatch: AppDispatch = useDispatch();
  const onDeleteHandler = () => {
    if (onDelete) onDelete(id);
    dispatch(markAsDeleted(id));
  };
  const onCancelHandler = () => {
    if (onCancel) onCancel(id);
    dispatch(updateLoadingStatus('succeeded'));
    dispatch(cancelDeletion(id));
  };

  return (
    <div className={styles.root}>
      <div className={styles.imageContainer}>
        <Image
          className={styles.image}
          src={picture}
          alt={name}
        />
        <div className={styles.timer}>
          <CountdownTimer
            milliseconds={4000}
            callback={onDeleteHandler}
          />
        </div>
      </div>
      <div className={styles.content}>
        <Typography className={styles.title}>
          {text['item']}{' '}
          <strong className={styles.name}>{name}</strong>{' '}
          <span>{text['removed']}</span>{' '}
          <span className={styles.hiddenMobile}>
            {text['fromCart']}
          </span>
        </Typography>
      </div>
      <div>
        <Button
          className={styles.button}
          variant="outlinedSolid"
          theme="primary"
          onClick={onCancelHandler}
        >
          {text['return']}
        </Button>
      </div>
    </div>
  );
};
